import React, {useRef} from "react";
import { Form, Checkbox } from 'antd';
import { registerUser } from "../../stateManagement/actions/auth";
import { useDispatch } from "react-redux";
import BasicFormButtons from "./basicFormButtons";
import InputFormField from "./inputFormField";

const NewUserForm = ({reloadData}) => {

    // Form reference for resetting
    const formRef = useRef(null);

    const dispatch = useDispatch();

    //Reset form fields
    const handleReset = () => formRef.current?.resetFields();

    // Handle form submission
    const onFinish = (values) => {
        // Dispatch action to add website
        dispatch(registerUser(values));
        // Reset form and reload data
        handleReset();
        reloadData();
    };

    return(
        <Form ref={formRef} onFinish={onFinish}>
            <InputFormField 
                label="Email:" 
                name="email"
            />
            <InputFormField 
                label="Password:" 
                name="password" 
                privacyMode={true}
            />
            <InputFormField 
                label="Access:" 
                name="access"
            />
            <InputFormField 
                label="Secret key:" 
                name="key" 
                privacyMode={true}
            />
            <Form.Item name="subAccount" valuePropName="checked" initialValue={false}>
                <Checkbox>THD subaccount</Checkbox>
            </Form.Item>
            <BasicFormButtons handleReset={handleReset}/>
        </Form>
    )
}

export default NewUserForm;